export enum ExplanationType {
  ImageEtTexte = 1,
  FlexColsTexte = 2,
  ButtonsPopUp = 3,
  ImageFixePopUp = 4,
}
